export enum TaxTerritory {
  ARABA = 'ARABA',
  BIZKAIA = 'BIZKAIA',
  GIPUZKOA = 'GIPUZKOA',
  NAVARRE = 'NAVARRE',
  CANARY_ISLANDS = 'CANARY_ISLANDS',
  CEUTA = 'CEUTA',
  MELILLA = 'MELILLA',
  SPAIN_OTHER = 'SPAIN_OTHER',
}

export const TAX_TERRITORY_LABELS: Record<TaxTerritory, string> = {
  [TaxTerritory.ARABA]: 'Araba',
  [TaxTerritory.BIZKAIA]: 'Bizkaia',
  [TaxTerritory.GIPUZKOA]: 'Gipuzkoa',
  [TaxTerritory.NAVARRE]: 'Navarre',
  [TaxTerritory.CANARY_ISLANDS]: 'Canary Islands',
  [TaxTerritory.CEUTA]: 'Ceuta',
  [TaxTerritory.MELILLA]: 'Melilla',
  [TaxTerritory.SPAIN_OTHER]: 'Spain Other',
}
